import { NavLink } from "react-router-dom";
import { Heart, Home, LayoutGrid, ShoppingCart, User } from "lucide-react";
import { useStore } from "@/context/StoreContext";
import { useAuth } from "@/context/AuthContext";

export function MobileBottomNav() {
  const { cartCount, favorites } = useStore();
  const { user } = useAuth();

  const tabs = [
    { label: "Accueil", to: "/", icon: Home, testId: "tab-home" },
    { label: "Catégories", to: "/categories", icon: LayoutGrid, testId: "tab-categories" },
    { label: "Panier", to: "/panier", icon: ShoppingCart, badge: cartCount, testId: "tab-cart" },
    { label: "Favoris", to: "/favoris", icon: Heart, badge: favorites.length, testId: "tab-favorites" },
    { label: "Compte", to: user ? "/compte" : "/connexion", icon: User, testId: "tab-account" },
  ];

  return (
    <nav
      data-testid="mobile-bottom-nav"
      className="fixed bottom-0 left-0 right-0 z-[70] border-t border-line bg-white/95 pb-[env(safe-area-inset-bottom)] backdrop-blur-lg lg:hidden"
    >
      <div className="flex h-16 items-stretch">
        {tabs.map(({ label, to, icon: Icon, badge, testId }) => (
          <NavLink
            key={label}
            to={to}
            end={to === "/"}
            data-testid={testId}
            className={({ isActive }) =>
              `relative flex flex-1 flex-col items-center justify-center gap-1 text-[10.5px] font-semibold transition-colors duration-200 ${
                isActive ? "text-brand" : "text-slate-500"
              }`
            }
          >
            {({ isActive }) => (
              <>
                <span className="relative">
                  <Icon className="h-[21px] w-[21px]" strokeWidth={isActive ? 2.5 : 1.9} />
                  {badge > 0 && (
                    <span className="absolute -right-2.5 -top-1.5 flex h-[16px] min-w-[16px] items-center justify-center rounded-full bg-rose-500 px-1 text-[9px] font-bold text-white">
                      {badge}
                    </span>
                  )}
                </span>
                {label}
                {isActive && <span className="absolute top-0 h-[3px] w-9 rounded-b-full bg-brand" />}
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}

export default MobileBottomNav;
